import { render, staticRenderFns } from "./BloodTypeDelete.vue?vue&type=template&id=778c2e7d&"
import script from "./BloodTypeDelete.vue?vue&type=script&lang=js&"
export * from "./BloodTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports